import { SealCheck } from "@phosphor-icons/react"
import { BaseButton } from "@tokenterminal/core/ui/button/Button"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Tooltip } from "@tokenterminal/core/ui/overlays/tooltip/Tooltip"

type StandardizedListingIconProps = {
  iconWidth?: number
}

const StandardizedListingIcon = ({
  iconWidth = 14,
}: StandardizedListingIconProps) => {
  return (
    <Tooltip content="Standardized listings include metrics transformed from raw blockchain data by TT's research team.">
      <BaseButton className="cursor-default">
        <Icon
          as={SealCheck}
          className="text-cyan-500"
          weight="fill"
          width={iconWidth}
        />
      </BaseButton>
    </Tooltip>
  )
}

export default StandardizedListingIcon
